export const colaboradores = [
    { logo: require("../../assets/images/logos/cece.png") },
    { logo: require("../../assets/images/logos/fundacion-botin.jpg") },
    { logo: require("../../assets/images/logos/ceu.png") },
    { logo: require("../../assets/images/logos/Colegios arenales.png") },

    { logo: require("../../assets/images/logos/Navarra.jpg") },
    { logo: require("../../assets/images/logos/invenio.jpeg") },
    { logo: require("../../assets/images/logos/universidad-villanueva.jpg") },
    { logo: require("../../assets/images/logos/Universidad de lisboa.jpg") },

    { logo: require("../../assets/images/logos/identitas.png") },
    { logo: require("../../assets/images/logos/trilema.png") },
    { logo: require("../../assets/images/logos/PRADOREY_logo.jpg") },
    { logo: require("../../assets/images/logos/colegio-nss.jpg") },

    { logo: require("../../assets/images/logos/santamaria.png") },
    { logo: require("../../assets/images/logos/santamariablanca.png") },
    { logo: require("../../assets/images/logos/Cambrils.png") },
    { logo: require("../../assets/images/logos/logoexploarte.png") },

    { logo: require("../../assets/images/logos/monte-tabor-nazaret.png") },
    { logo: require("../../assets/images/logos/san-jose-Chicureo.jpg") },
    { logo: require("../../assets/images/logos/Sagrada familia.png") },
    { logo: require("../../assets/images/logos/EMEX.png") },

    { logo: require("../../assets/images/logos/daccapo.png") },
    { logo: require("../../assets/images/logos/Schoenstatt.png") },

    /* 
      {logo:require("../../assets/images/logos/ceu-abat-oliva.png")},
      {logo:require("../../assets/images/logos/Ceu San Chinarro.png")},
      {logo:require("../../assets/images/logos/colegio-monte-tabor.jpg")},           
      {logo:require("../../assets/images/logos/espacios-con-sentido.png")},
      {logo:require("../../assets/images/logos/fundacion-pentecostes.jpg")},
      {logo:require("../../assets/images/logos/fundacion-tiempos-mas-nuevos.jpg")},
      */
];